import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmFolder2IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmFolder2Icon = ({ className, ...props }: EmFolder2IconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.93887 4.80048V4.50141C7.93887 3.90501 7.58137 3.78126 7.1895 3.85173L3.90668 4.4447C3.51309 4.51516 3.22434 4.86923 3.22434 5.28173V6.04485C3.22434 6.32329 3.03012 6.5622 2.76372 6.61032L2.70528 6.62063C2.47497 6.66188 2.30481 6.86813 2.30481 7.11048L2.49043 19.8344C2.49043 19.8344 2.47668 20.0372 2.66747 20.0509C2.86512 20.0647 3.01465 19.9134 3.21231 19.867L18.6192 16.1958C18.8495 16.1545 19.0197 15.9483 19.0197 15.7059V4.35704C19.0197 4.04938 18.7515 3.81563 18.4576 3.8672L8.77934 5.53266C8.34106 5.61001 7.93887 5.44501 7.93887 4.80048Z"
      fill="#F3AB47"
    />
    <path
      d="M19.3461 15.7524L19.6933 5.50002C19.6933 5.19236 19.4252 4.95861 19.1313 5.01017L9.45986 6.66361C9.00955 6.74096 8.67095 7.11736 8.64345 7.57283L8.60392 8.2208C8.57298 8.73986 8.18626 9.16955 7.67408 9.25549L3.78111 9.91033C3.39611 9.97564 3.11251 10.3091 3.11251 10.701L2.66736 20.0475C2.66736 20.0475 2.72408 20.0716 3.36173 19.91L18.693 16.2817C18.925 16.2439 19.1897 16.0274 19.3461 15.7524Z"
      fill="#FFE36C"
    />
    <path
      d="M3.71753 10.0943L7.6294 9.42566C8.60909 9.20738 8.7655 8.83613 8.76378 8.05581L8.7655 7.85472C8.79644 7.26691 9.08175 6.91972 9.66097 6.82003L19.2292 5.16144"
      stroke="#FFF9C4"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.34375"
    />
  </svg>
);

export default EmFolder2Icon;
